import React from "react";
import {
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonContent,
    IonIcon, IonFooter
} from "@ionic/react";
import {
    documentTextOutline,
    mailOutline,
    businessOutline,
    personOutline,
    locationOutline,
    arrowBack
} from "ionicons/icons";
import {callFunctionToDownload} from "../lib/downloadHelper";

const JobAppliedMemberDataModal = ({ isOpen, onClose, memberData }) => {
    if (!memberData) return null;

    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onClose}
            initialBreakpoint={1}
            breakpoints={[0, 0.6, 0.9, 1]}
            backdropDismiss={true}
            handleBehavior="cycle"
        >
            <IonHeader className="job_detail_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton className={"close_job_post_button"} onClick={onClose}>
                            <IonIcon icon={arrowBack}/>
                        </IonButton>
                    </IonButtons>
                    <IonTitle>Applicant Details</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding">
                <div className="applied_member_container">
                    {/* Header */}
                    <div className="member_header">
                        <IonIcon icon={personOutline} className="icon" />
                        <div className="info">
                            <h2><strong>{memberData.name}</strong></h2>
                            <p>Category: {memberData.category}</p>
                        </div>
                    </div>

                    {/* Details */}
                    <div className="member_details">
                        <div className="detail_item">
                            <IonIcon icon={mailOutline} className="icon" />
                            <p>{memberData.email}</p>
                        </div>

                        <div className="detail_item">
                            <IonIcon icon={locationOutline} className="icon" />
                            <p>Location: {memberData.location}</p>
                        </div>

                        <div className="detail_item">
                            <IonIcon icon={businessOutline} className="icon" />
                            <p>Work Type: {memberData.work_type}</p>
                        </div>
                    </div>

                    {/* Salary info */}
                    <div className="member_salary">
                        <div className="salary_box">
                            <p><strong>Current Salary:</strong> {memberData.current_salary}</p>
                        </div>
                        <div className="salary_box">
                            <p><strong>Expected Salary:</strong> {memberData.expected_salary}</p>
                        </div>
                    </div>

                    {/* View CV Button */}
                    <div className="view_cv_container">
                        <button
                            className="view_cv_btn"
                            onClick={() => callFunctionToDownload(memberData.cv_url)}
                        >
                            <IonIcon icon={documentTextOutline} className="icon" />
                            Download CV
                        </button>
                    </div>

                    {/* Submitted Date */}
                    <div className="submitted_info">
                        <p>
                            Submitted on {new Date(memberData.created_at).toLocaleDateString()}
                        </p>
                    </div>
                </div>
            </IonContent>
            <IonFooter className="blank_footer_bar">
                <IonToolbar>

                </IonToolbar>
            </IonFooter>
        </IonModal>
    );
};

export default JobAppliedMemberDataModal;
